var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    _vm._g(
      {
        staticClass: "_lb",
        class:
          ((_obj = {
            _fo: _vm.focused,
            _filt: _vm.filtered,
            _da: _vm.disabled,
            _inv: _vm.showvalid && !_vm.valid,
          }),
          (_obj["_le" + _vm.appearance] = _vm.appearance),
          _obj),
        style: { width: _vm.width, height: _vm.height },
      },
      _vm.__fwd
    ),
    [
      _vm.filtered
        ? _c("span", { staticClass: "_fldi" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter,
                  expression: "filter",
                },
              ],
              staticClass: "_fldin",
              attrs: {
                autocomplete: "off",
                autocorrect: "off",
                autocapitalize: "off",
              },
              domProps: { value: _vm.filter },
              on: {
                focus: _vm.__focus,
                blur: _vm.__blur,
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.filter = $event.target.value
                },
              },
            }),
          ])
        : _vm._e(),
      _c(
        "ul",
        _vm._g(
          {
            ref: "_in",
            attrs: {
              role: "listbox",
              tabindex: _vm.inert ? -1 : _vm.tabindex || 0,
            },
            on: {
              keydown: _vm._keydown,
              keyup: _vm._keyup,
              touchstart: _vm._touchstart,
              touchend: _vm._touchend,
              touchmove: _vm._touchmove,
              scroll: _vm._scroll,
              wheel: _vm._wheel,
            },
          },
          _vm.__on
        ),
        [
          _vm._l(_vm.data, function (opt) {
            return [
              opt.child
                ? [
                    _c(
                      "li",
                      { attrs: { inert: "" } },
                      [
                        _vm._t(
                          "default",
                          function () {
                            return [_vm._v(_vm._s(opt.label))]
                          },
                          null,
                          opt
                        ),
                      ],
                      2
                    ),
                    _vm._l(opt.child, function (subopt) {
                      return _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isFiltered(subopt),
                              expression: "isFiltered(subopt)",
                            },
                          ],
                          staticClass: "_ind",
                          attrs: {
                            role: "option",
                            "data-value": _vm.getval(subopt),
                          },
                        },
                        [
                          _vm._t(
                            "default",
                            function () {
                              return [
                                _vm._v(
                                  _vm._s(
                                    typeof subopt === "object"
                                      ? subopt.label
                                      : subopt
                                  )
                                ),
                              ]
                            },
                            null,
                            typeof subopt === "object"
                              ? subopt
                              : { value: subopt }
                          ),
                        ],
                        2
                      )
                    }),
                  ]
                : _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isFiltered(opt),
                          expression: "isFiltered(opt)",
                        },
                      ],
                      attrs: { role: "option", "data-value": _vm.getval(opt) },
                    },
                    [
                      _vm._t(
                        "default",
                        function () {
                          return [
                            _vm._v(
                              _vm._s(typeof opt === "object" ? opt.label : opt)
                            ),
                          ]
                        },
                        null,
                        typeof opt === "object" ? opt : { value: opt }
                      ),
                    ],
                    2
                  ),
            ]
          }),
          _vm._t("bg"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }